(function () {
  ConfirmRegoController.$inject = ["$location", "$filter", "API_URL", "$http", "$rootScope"];
  angular.module('calendarApp').controller('ConfirmRegoController', ConfirmRegoController);

  function ConfirmRegoController($location, $filter, API_URL, $http, $rootScope) {
    var rego = this;

    rego.init = function () {
      // All appointments at this stage must be in local storage
      var appointments = localStorage.getItem('reserved-appointments'); // Set on the review page

      rego.requiresPayment = localStorage.getItem('requires-payment') ? JSON.parse(localStorage.getItem('requires-payment')) : false;

      if (!appointments) {
        $location.path('/');
        return;
      }

      appointments = JSON.parse(appointments);
      rego.appointments = appointments;
      rego.serviceID = appointments[0].serviceid;
      rego.regoForm = angular.copy(smooth.forms.registration);
      rego.regoData = {};
      $rootScope.throbber && $rootScope.throbber.show();
      $http.get(API_URL + '/api/v1/calendar/customer').then(function (reply) {
        $rootScope.throbber && $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          $rootScope.throbber.showError('Sorry but an error occurred: ' + response.msg);
          return;
        }

        var customer = response.customer;
        delete customer._id; // Complete basic registration email

        rego.customer = customer;
        rego.form = {
          firstname: customer.firstname,
          lastname: customer.lastname,
          email: customer.email
        };

        if (response.customer.reginfo) {
          rego.regoData = response.customer.reginfo;
        }
      }, function (error) {
        console.error(error);
        $rootScope.throbber.showError('Sorry but an error occurred');
      });
    };

    rego.init();

    rego.submitRego = function () {
      if (!rego.form.firstname || !rego.form.lastname || !rego.form.email) {
        alert('Please complete first name, last name and email fields');
        return;
      }

      rego.form.reginfo = rego.regoData || {};
      $rootScope.throbber && $rootScope.throbber.show();
      $http.put(API_URL + '/api/v1/calendar/customer', {
        customerinfo: rego.form
      }).then(function (reply) {
        $rootScope.throbber && $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          $rootScope.throbber.showError('Sorry there was an error with this request: ' + response.msg);
          return;
        }

        if (smooth.forms.booking && smooth.forms.booking.length) {
          var doBooking = false;
          smooth.forms.booking.forEach(function (form) {
            if (form.serviceid === 'default' || form.serviceid === rego.serviceID) {
              doBooking = true;
            }
          });

          if (doBooking) {
            $location.path('/bookingform');
            return;
          }
        } // Go to payment page if required


        if (rego.requiresPayment) {
          $location.path('/choose-payment');
          return;
        }

        $rootScope.throbber && $rootScope.throbber.show();
        var appointmentIDs = rego.appointments.map(function (appointment) {
          return appointment._id;
        }); // No payment required. Confirm appointments and go to confirmation page.

        $http.put(API_URL + '/api/v1/calendar/appointment/confirmunpaid', {
          appointmentids: appointmentIDs
        }).then(function (reply) {
          $rootScope.throbber.hide();
          var response = reply.data;

          if (!response.success) {
            if (response.alreadydeleted) {
              $rootScope.throbber.showError("Unfortunately an error has occurred with this reservation. We're very sorry but you will need to restart the reservation process", function () {
                localStorage.removeItem('reserved-appointments');
                $location.path('/');
              });
              return;
            }

            return $rootScope.throbber.showError('Sorry but there was an error with this query ' + response.msg);
          } // Update local storage, redirect to confirmation page


          localStorage.removeItem('reserved-appointments');
          localStorage.setItem('new-appointments', JSON.stringify(response.appointments));
          $location.path('/confirm');
        });
      }, function (error) {
        console.error(error);
        $rootScope.throbber.showError('Sorry but an error occurred with this request: ');
      });
    };

    rego.cancel = function () {
      var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

      if (!confirm(cancelMessage)) {
        return;
      }

      $location.path('/');
    };
  }
})();